import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountResponse } from '../core/models/account-response';
import { environment } from "environments/environment";

@Injectable()
export class ProfileService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getProfiles({ sortDirection, sortField, pageIndex, pageSize, activeFilters }: { filter: string; sortDirection: 'asc' | 'desc' | ''; sortField: string; pageIndex: number; pageSize: number; activeFilters: unknown[]; }): Observable<AccountResponse> {
    
    const allStringFilterAux = [];
    activeFilters.forEach((item) => {
        if (item['value'] != null && item['value'] != '') {
            const stringFilterAux = [item['id'],item['value']];
            allStringFilterAux.push(stringFilterAux.join('::'));
        }
    });

    const queryFilter = allStringFilterAux.join('--');

    
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/profiles`, {
      params: params
      }).pipe(
          
          map(res =>  <AccountResponse>res)
      );    
    
  }

  getProfileStatus(): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/profiles/status`);
  }

  getProfile(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/profiles/${id}`);
  }

  editProfile(profile, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/profiles/${id}`, profile);
  }

  getProfileAdditionalInfo(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/profiles/${id}/info`);
  }

  editProfileAdditionalInfo(id: string, additionalInfo: any): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/profiles/${id}/info`, additionalInfo);
  }

  getProfilecChats(id: string){
    return this._httpClient.get(`${environment.apiUrl}/profiles/${id}/chats`);
  }

  
  
  


  getProfileMessages(id: string, pageIndex: number = 0, pageSize: number = 10): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/profiles/${id}/messages?page=${pageIndex}`);
  }

  getDataRawDownload(id: string): Observable <Blob> {
      return this._httpClient.get(`${environment.apiUrl}/profiles/${id}/download_raw`, { responseType: 'blob' });
  }  
  
}
